import React, { useContext, useEffect, useState } from "react";
import {
  TextField,
  Button,
} from "@mui/material";
import AsyncSelect from "react-select/async";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast from "react-hot-toast";
import blogFetch from "../../../axios/config";
import pendencyData from "./nls/pt-BR.json";
import Context from "../../../context/Context";
import language from '../../../nls/language.json';

const INITIAL_STATE_CREATE_PENDENCY = {
  Pend_Ordem: "",
  Pend_Status: "ABERTO",
  Pend_Mot_key: 0,
  PendMot_Responsavel: ""
}

function Pendency({ data, setIdScreenFicha }) {
  const [body, setBody] = useState(INITIAL_STATE_CREATE_PENDENCY);
  const [loading, setLoading] = useState(false);

  const {
    statusPendencia,
    setShowModalFicha,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    setBody({
      ...body,
      Pend_Ordem: data.ordem,
    });
  }, [])

  const getPendenciasMotivo = async () => {
    try {
      const response = await blogFetch.get(`/ISAGA_PendenciasMotivos/sectorOrigin/${data.ordem_SetAtual}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const postPendencia = async (params) => {
    try {
      setLoading(true);

      if(params.PendMot_Responsavel == "Janela"){

        params.Pend_Status = "EM ANDAMENTO"
        params.Pend_DataPrevisao = new Date().toISOString();
      }

      await blogFetch.post("/ISAGA_Pendencias", params);


      setBody(INITIAL_STATE_CREATE_PENDENCY);
      toast.success(pendencyData.pendency.register.success, {
        duration: 4000,
      });
      setShowModalFicha(false);
      setIdScreenFicha(2);
    } catch (error) {
      console.error(error);
      toast.error(pendencyData.pendency.register.error, {
        duration: 4000,
      });
    }
    finally {
      setLoading(false);
    }
  }

  const handleMotivo = ({ name, value }) => {
    setBody({
      ...body,
      [name]: value
    });
  }

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column p-3">
        <h2
          className="d-flex justify-content-center"
          style={{ fontFamily: "sans-serif" }}
        >
          {language[selectedCountry.name].Dashboard.pecasSetor.ficha.pendencia.modal.adicionar.title}
        </h2>
        {loading ? (
          <div>
            <FontAwesomeIcon icon={faSpinner} spin size="2x" />
          </div>
        ) : !statusPendencia ? (
          <div className="d-flex flex-column">
            <div className="d-flex flex-row">
              <TextField
                className="header-flex"
                id="outlined-multiline-flexible"
                multiline={true}
                maxRows={10}
                disabled
                style={{ width: 160 }}
                label="Ordem"
                value={data.ordem}
              />
              <TextField
                className="header-flex"
                id="outlined-multiline-flexible"
                multiline={true}
                maxRows={10}
                disabled
                style={{ width: 160, marginLeft: "15px" }}
                label="Status"
                value="ABERTO"
              />
            </div>
            <div className="w-100 mt-3 h-10">
              <AsyncSelect
                cacheOptions
                defaultOptions
                placeholder="Selecionar Motivo"
                getOptionLabel={(e) => e.pendMot_Descricao}
                getOptionValue={(e) => e.pendMot_Descricao}
                loadOptions={getPendenciasMotivo}
                onChange={({ pendMot_Key, pendMot_Responsavel }) => setBody({
                  ...body,
                  "Pend_Mot_key": pendMot_Key,
                  "PendMot_Responsavel": pendMot_Responsavel
                })}
              />
            </div>
            <div className="d-flex mt-3">
              <TextField
                className="header-flex"
                id="outlined-multiline-flexible"
                multiline={true}
                maxRows={10}
                style={{ width: "100%" }}
                placeholder="Setor Responsável"
                disabled
                value={body.PendMot_Responsavel ? body.PendMot_Responsavel : ""}
              />
            </div>
            <div className="d-flex flex justify-content-end mt-3">
              <Button
                variant="contained"
                onClick={() => postPendencia(body)}
                disabled={body.Pend_Mot_key === 0}
              >
                <div>
                  {language[selectedCountry.name].Dashboard.pecasSetor.ficha.pendencia.modal.adicionar.btnSalvar}
                </div>
              </Button>
            </div>
          </div>
        ) : (
          <h4>
            <span className="badge bg-warning text-dark">
              {language[selectedCountry.name].Dashboard.pecasSetor.ficha.pendencia.modal.adicionar.jaExistePendencia}
            </span>
          </h4>
        )}
      </div>
    </div>
  );
}

export default Pendency;
